import { FunctionComponent } from 'react';

type Props = {
    children: React.ReactNode;
};

const PinboardMessageList: FunctionComponent<Props> = ({ children }) => (
  <div className="hs-list">{children}</div>
)

export default PinboardMessageList;
